// socket events
// they need to match the back-end values
const socketEvent = {
  notificationReceived: 'notificationReceived',
  subscribeToOrderMessages: 'subscribeToOrderMessages',
  unsubscribeFromOrderMessages: 'unsubscribeFromOrderMessages',
  messageReceived: 'messageReceived',
  subscribeToUser: 'subscribeToUser',
  unsubscribeFromUser: 'unsubscribeFromUser',
  userActivityStatusChanged: 'userActivityStatusChanged',
  subscribeToOrderSigner: 'subscribeToOrderSigner',
  unsubscribeFromOrderSigner: 'unsubscribeFromOrderSigner',
  orderSignerActivityStatusChanged: 'orderSignerActivityStatusChanged',
  notaryBidChanged: 'notaryBidChanged',
  appointmentStatusChanged: 'appointmentStatusChanged'
} as const;

export default socketEvent;